export default __webpack_public_path__ + "static/media/milestone 75.ebb6ede2.svg";